/* intermodo-track.js — storefront interaction + commerce event firing.
 *
 * THE GAP THIS CLOSES: the live theme only emits `page_view`. The ingest endpoint
 * POST /api/storefront/web-events/track already accepts cta_click, product_view,
 * collection_view, add_to_cart, search, etc. — they just aren't being sent. This
 * fires them from the new sections so the redesign ships measurable (bounce/ATC/
 * funnel metrics in customer_growth_metrics become real).
 *
 * SESSION JOIN (critical): events MUST carry the SAME session_id (UUID) + anon_id
 * as the existing page_view tracker, or they won't roll up into the same
 * web_session. This reads the existing tracker's session via getSession() below —
 * point it at however the current pixel exposes its IDs. If it can't find one, it
 * no-ops loudly rather than inventing a second, unjoinable session.
 */
(function () {
  var ENDPOINT = (window.IM_TRACK_ENDPOINT ||
    "https://im-ops-dashboard-production.up.railway.app") + "/api/storefront/web-events/track";

  // ---- session: reuse the existing tracker's IDs (DO NOT mint a new pair) ----
  function getSession() {
    // 1) preferred: the existing tracker exposes its session on a global
    if (window.__imSession && window.__imSession.session_id) return window.__imSession;
    // 2) fallback: common localStorage keys the current pixel may use
    try {
      var sid = localStorage.getItem("im_session_id") || localStorage.getItem("session_id");
      var aid = localStorage.getItem("im_anon_id") || localStorage.getItem("anon_id");
      if (sid && aid) return { session_id: sid, anon_id: aid };
    } catch (e) {}
    return null; // no joinable session — see note above
  }

  function deviceType() {
    var w = window.innerWidth || 1024;
    return w < 600 ? "mobile" : w < 1024 ? "tablet" : "desktop";
  }

  function send(eventType, extra) {
    var s = getSession();
    if (!s) { if (window.console) console.warn("[im-track] no joinable session; skipped", eventType); return; }
    var ev = Object.assign({
      event_type: eventType,
      session_id: s.session_id,
      anon_id: s.anon_id,
      occurred_at: new Date().toISOString(),
      page_url: location.href,
      page_path: location.pathname,
      page_title: document.title,
      device_type: deviceType()
    }, extra || {});
    try {
      var body = JSON.stringify({ events: [ev] });
      // sendBeacon survives navigation (click → page change); fetch is the fallback
      if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
      else fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: body, keepalive: true });
    } catch (e) {}
  }
  window.imTrack = send; // exposed so sections / inline handlers can fire custom events

  // ---- delegated declarative tracking via data attributes ----
  // <a data-im-track="cta_click" data-im-label="Enter the Collection"> ...
  document.addEventListener("click", function (e) {
    var el = e.target.closest("[data-im-track]");
    if (!el) return;
    var type = el.getAttribute("data-im-track");
    send(type, {
      collection_handle: el.getAttribute("data-im-collection") || undefined,
      sku: el.getAttribute("data-im-sku") || undefined,
      properties: {
        label: el.getAttribute("data-im-label") || (el.textContent || "").trim().slice(0, 80),
        section: el.getAttribute("data-im-section") || undefined,
        href: el.getAttribute("href") || undefined
      }
    });
  }, { capture: true });

  // ---- add_to_cart: intercept theme cart form submits + AJAX add buttons ----
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      var sku = (form.querySelector("[data-im-sku]") || {}).getAttribute &&
        form.querySelector("[data-im-sku]").getAttribute("data-im-sku");
      send("add_to_cart", { sku: sku || undefined,
        properties: { variant_id: (form.querySelector('[name="id"]') || {}).value } });
    }
  }, { capture: true });
})();

/* PURCHASE + CHECKOUT (off-theme): checkout runs on Shopify's domain, so capture
 * `purchase` / `checkout_start` with a Shopify WEB PIXEL (Settings → Customer events
 * → Add custom pixel) subscribing to analytics.subscribe("checkout_completed", ...)
 * and POSTing the same {events:[{event_type:"purchase", session_id, anon_id, ...}]}
 * shape to ENDPOINT. Conversion is already covered by daily_pnl orders, so this is
 * lower priority than the on-theme events above. */
